import { useQuery } from '@tanstack/react-query';
import { supabase } from '../../lib/supabase.js';
import { qk } from '../../lib/api/queryKeys.js';

export interface SettingsRow {
  key: string;
  value_jsonb: Record<string, unknown>;
}

export function useSettings() {
  return useQuery({
    queryKey: qk.settings,
    queryFn: async () => {
      const { data } = await supabase
        .from('settings')
        .select('key,value_jsonb');
      return (data ?? []) as SettingsRow[];
    },
    staleTime: 5 * 60_000,
  });
}
